import Vue from 'vue'
import VueRouter from 'vue-router'
import Tyc from '../views/tyc.vue'

Vue.use(VueRouter)

const AmLayout = () => import('@/amatea/AmLayout.vue')
const LandingScreen = () => import('@/amatea/screens/LandingScreen.vue')
const SummaryScreen = () => import('@/amatea/screens/SummaryScreen.vue')
const MethodScreen = () => import('@/amatea/screens/MethodScreen.vue')
const CardScreen = () => import('@/amatea/screens/CardScreen.vue')
const PSEScreen = () => import('@/amatea/screens/PSEScreen.vue')
const NequiScreen = () => import('@/amatea/screens/NequiScreen.vue')
const BancoScreen = () => import('@/amatea/screens/BancoScreen.vue')
const ProcessingScreen = () => import('@/amatea/screens/ProcessingScreen.vue')
const SuccessScreen = () => import('@/amatea/screens/SuccessScreen.vue')
const SoonScreen = () => import('@/amatea/screens/SoonScreen.vue')
const EmpresaScreen = () => import('@/amatea/screens/EmpresaScreen.vue')
const TrackingScreen = () => import('@/amatea/screens/TrackingScreen.vue')

const routes = [
  {
    path: '/',
    component: AmLayout,
    children: [
      { path: '', name: 'home', component: LandingScreen },
      { path: 'siembra', name: 'siembra-landing', component: LandingScreen },
      { path: 'siembra/resumen', name: 'siembra-summary', component: SummaryScreen },
      { path: 'siembra/metodo', name: 'siembra-method', component: MethodScreen },
      { path: 'siembra/tarjeta', name: 'siembra-card', component: CardScreen },
      { path: 'siembra/pse', name: 'siembra-pse', component: PSEScreen },
      { path: 'siembra/nequi', name: 'siembra-nequi', component: NequiScreen },
      { path: 'siembra/bancolombia', name: 'siembra-banco', component: BancoScreen },
      { path: 'siembra/procesando', name: 'siembra-processing', component: ProcessingScreen },
      { path: 'siembra/exito', name: 'siembra-success', component: SuccessScreen },
      // Secciones aún no rediseñadas — placeholder "Próximamente"
      { path: 'huella', name: 'huella', component: SoonScreen },
      { path: 'empresas', name: 'empresas', component: EmpresaScreen },
      { path: 'sobre', name: 'sobre', component: SoonScreen },
      { path: 'seguimiento', name: 'seguimiento', component: TrackingScreen },
    ],
  },

  // Redirects legacy
  { path: '/Siembra', redirect: '/siembra' },
  { path: '/siembra-amatea', redirect: '/siembra' },
  { path: '/siembra-amatea/:rest+', redirect: to => `/siembra/${to.params.rest}` },
  { path: '/thanks', redirect: to => ({ path: '/siembra/exito', query: to.query }) },

  // Páginas legales (sin layout)
  { path: '/terminosycondiciones', name: 'tyc', component: Tyc },

  // Cualquier otra ruta → home nuevo
  { path: '*', redirect: '/' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes,
})

export default router
